import { useState } from "react";

export const useCheckUpdates = () => {
  const [processUpdates, setProcessUpdates] = useState(true);

  return {
    processUpdates,
    setProcessUpdates,
  };
};
